<div class="document-badge" [ngClass]="{ 'op-body-1-font': !small, 'op-label-font': small }" *transloco="let t">
	<div id="{{ id + '_badge' }}" class="badge" [ngClass]="{ 'icon-align': icon, small: small }">
		<mat-icon *ngIf="icon" [ngClass]="{ small: small }" svgIcon="{{ icon }}"></mat-icon>
		<div [class]="{ 'icon-text': icon }">
			<ng-content></ng-content>
		</div>
	</div>
</div>
